import React from 'react';
import { FaCode } from "react-icons/fa6";


const SplashPage = () => {
  return (
    <div className="h-screen w-full fixed flex flex-col justify-between items-center bg-fj">

      <div></div>
      <div> <FaCode className="w-22 h-22 cursor-pointer m-3 " style={{ color: 'white' }}/> </div>
      <div></div>

    </div>
  );
};

export default SplashPage;
